import { useSelector } from 'react-redux';
import { getStepTitle } from '../utils/getStepTitle';
import { Step } from 'signup-constants/Step';
import { OptionalFormattedMessage } from './OptionalFormattedMessage';
import { Text } from 'foundations-components/components/Text';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { LayoutType } from 'signup-components/types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TITLE_CENTERED_STEPS = [Step.ExistingUser, Step.Verification, Step.CodeVerification];
export const StepTitle = ({
  stepKey,
  message = null,
  children,
  shouldShowDefault = true,
  messageOptions
}) => {
  const title = useSelector(getStepTitle);
  const {
    layoutType
  } = useLayoutTemplate();
  const isExistingUser = stepKey === Step.ExistingUser;
  const isSidePanel = layoutType === LayoutType.SidePanel;
  const shouldCenterTitle = !isSidePanel && TITLE_CENTERED_STEPS.includes(stepKey);
  const marginBlockEnd = isExistingUser ? '200' : '400';
  if (messageOptions && message && isValidI18nKey(message)) {
    return /*#__PURE__*/_jsx(Text, {
      as: isExistingUser ? undefined : 'h2',
      marginBlockEnd: marginBlockEnd,
      textAlign: shouldCenterTitle ? 'center' : undefined,
      typography: "heading-600",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message,
        options: messageOptions
      })
    });
  }
  return /*#__PURE__*/_jsxs(Text, {
    as: isExistingUser ? undefined : 'h2',
    marginBlockEnd: marginBlockEnd,
    textAlign: shouldCenterTitle ? 'center' : undefined,
    typography: "heading-600",
    children: [shouldShowDefault && /*#__PURE__*/_jsx(OptionalFormattedMessage, {
      message: message || title
    }), children]
  });
};